import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MAIN_MAIN_ROUTES } from './main.routes';

@NgModule({
    imports: [RouterModule.forChild(MAIN_MAIN_ROUTES)],
    exports: [RouterModule]
})
export class MainRoutingModule {}
